import faker from '@faker-js/faker';
import { me } from './test.data';
import { Channel, Message } from './types/channel.types';
import { TinyUser } from './types/userProfile';

const avatars = [
  'https://images.pexels.com/photos/6702971/pexels-photo-6702971.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/7327238/pexels-photo-7327238.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/9687427/pexels-photo-9687427.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/8258891/pexels-photo-8258891.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/9077158/pexels-photo-9077158.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/4757975/pexels-photo-4757975.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/2020992/pexels-photo-2020992.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/5405959/pexels-photo-5405959.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/4991106/pexels-photo-4991106.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/5834046/pexels-photo-5834046.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/6769765/pexels-photo-6769765.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/5777505/pexels-photo-5777505.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/6973709/pexels-photo-6973709.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/6213123/pexels-photo-6213123.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/9775683/pexels-photo-9775683.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/7773977/pexels-photo-7773977.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/7561677/pexels-photo-7561677.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/4386046/pexels-photo-4386046.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/6698512/pexels-photo-6698512.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/8721828/pexels-photo-8721828.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/8263351/pexels-photo-8263351.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/447329/pexels-photo-447329.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/2004352/pexels-photo-2004352.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/167964/pexels-photo-167964.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/1097456/pexels-photo-1097456.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/3151263/pexels-photo-3151263.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/705421/pexels-photo-705421.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/598917/pexels-photo-598917.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/801885/pexels-photo-801885.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/1770803/pexels-photo-1770803.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  'https://images.pexels.com/photos/3841338/pexels-photo-3841338.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
];

export const sampleMessages = [
  'I really think that this year is gonna be great.',
  'Yo, this new song is so sick!',
  'Thank GOD!!',
  'Can someone drop some gems here. I have been waiting for some new music',
  'I love music ❤️❤️❤️',
  'So much love for all of you guys, we have to keep supporting music',
  'Meh...',
  'What do you guys think the next album is going to sound like?',
];

export const generateMessages = (
  messageCount: number,
  users: TinyUser[]
): Message[] => {
  const messages: Message[] = [];
  const meUser: TinyUser = { username: me.username, avatarUrl: me.avatar };
  for (let i = 0; i < messageCount; i++) {
    const owned = Math.random() < 0.8 ? false : true;
    const message: Message = {
      id: faker.datatype.uuid(),
      owned: owned,
      user: owned
        ? meUser
        : users[Math.floor(100 * Math.random()) % users.length],
      message:
        sampleMessages[Math.floor(100 * Math.random()) % sampleMessages.length],
      date: faker.date.recent(),
      metadata: {},
    };
    messages.push(message);
  }
  return messages;
};

export const generateTinyUsers = (userCount: number): TinyUser[] => {
  const users: TinyUser[] = [];
  for (let i = 0; i < userCount; i++) {
    users.push({
      username: faker.internet.userName(),
      avatarUrl: avatars[Math.floor(100 * Math.random()) % avatars.length],
    });
  }
  return users;
};

export const generateChannel = (
  id: string,
  title: string,
  administrator: TinyUser,
  backgroundImage: string,
  pinnedMessage: string,
  description: string,
  listenerCount: number,
  messageCount: number,
  hasJoined: boolean,
  tags: string[],
  isPrivate: boolean,
  favourite: boolean
): Channel => {
  const listeners = generateTinyUsers(listenerCount);
  const messages = generateMessages(messageCount, listeners);
  return {
    id: id,
    title: title,
    backgroundImage: backgroundImage,
    administrator: administrator,
    pinnedMessage: pinnedMessage,
    description: description,
    topListners: [
      listeners[Math.floor(100 * Math.random()) % listeners.length],
      listeners[Math.floor(100 * Math.random()) % listeners.length],
    ],
    listeners: listeners,
    hasJoined: hasJoined,
    tags: tags,
    isPrivate: isPrivate,
    favourite: favourite,
    messages: [
      ...messages,
      {
        id: faker.datatype.uuid(),
        owned: false,
        user: administrator,
        message: pinnedMessage,
        date: faker.date.recent(),
        metadata: {},
      },
    ],
  };
};
